/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Otp_ResendInputs */

const he_auth_otp_resend = /** @type {(inputs: Auth_Otp_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שלח קוד מחדש`)
};

const en_auth_otp_resend = /** @type {(inputs: Auth_Otp_ResendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend code`)
};

/**
* | output |
* | --- |
* | "Resend code" |
*
* @param {Auth_Otp_ResendInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_otp_resend = /** @type {((inputs?: Auth_Otp_ResendInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Otp_ResendInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_otp_resend(inputs)
	return en_auth_otp_resend(inputs)
});